import jsPDF from "jspdf";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../../Service/ApiMethod";
import { HIRE_LIST, TIMESHEET_DOWNLOAD} from "../../Service/service";
// import ClientDetails from "../login/Popup/TimesheetDownload";
import 'jspdf-autotable';
import HireBoxBlackScreen from "./HireBoxBlackScreen";
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";

const HireBox = (props) => {
  // const [hireList, setHireList] = useState();
  // const [data, setData] = useState(false)
  const[blackScreenPopup, setBlackScreenPopup] =useState(false)
  const [ln,setLn] = useState('en')

  // const [clientDetail, setClientDetail] = useState(false);

  const navigate = useNavigate()

  const hire = props?.hire
    

useEffect(()=>{
  if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    } 
},[])
  
  // const vacancyId = params?.userid
  // console.log('vacancy', vacancyId)

  // const handleClick = () => {  
  //   console.log();
  //   let dataObj = {
  //     vacancy_id: vacancyId,
  //   };
  //   postData(dataObj, HIRE_LIST)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setHire(data?.data)
  //       console.log('Hired Candidates', data?.data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //     });
  // };
  // console.log("dataaaaa" , data)

  const download = (id) => {
    getData(TIMESHEET_DOWNLOAD+id)
      .then((response) => response.json())
      .then((data) => {
       
        
        
        
        // $('#api-data').DataTable({
        //   data: data,
        //   columns: [
        //     { data: 'id' },
        //     { data: 'name' },
        //     { data: 'email' }
        //   ]
        // });
        // console.log("data147852" ,data?.data );
       
       
        // <table  id="api-data">
        //   <thead>
        //     <tr>
        //     <th>Date</th>
        //     <th>Check In</th>
        //     <th>Check Out</th>
        //     <th>Total Hours</th>
        //     <th>Task Details</th>
        //     <th>Status</th>
        //     </tr>
      
        //   </thead>
        //   <tbody>
            
        //   </tbody>
        //   {/* <tr>
        //   <td>data.data[0].hire_date</td>
        //     <td>data.data[0].check_in_time</td>
        //     <td>data.data[0].check_out_time</td>
        //     <td>data.data[0]?.hours_worked</td>
        //     <td>data.data[0]?.task_details</td>
        //     <td>data.data[0]?.status</td>
        //   </tr> */}
        // </table>
      
         
        // console.log("coloum" , coloum)
         
        // const doc = new jsPDF();
        const marginLeft = 180;
        const unit = "px";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"
        const doc = new jsPDF(orientation, unit, size);
        const title = "Time sheet";
        const columns = ['Date', 'Check In', 'Check Out', 'Total Hours', 'Task Details', 'Status'];
        const rows = data?.data && data?.data?.map(user => {
          return (
            [user?.date, user?.check_in_time, user?.check_out_time, user?.hours_worked, user?.task_details, user?.status]
          )
        } );

        let content = {
          startY: 50,
          head: [columns],
          body: rows
        };
        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        // doc?.autoTable({
        //   head: [columns],
        //   body: rows
        // });



        // doc.text(JSON.stringify(data?.data ), 10, 10);
        // doc.autoTable({ html: '#api-data' });

        // Save the PDF file
        doc.save('CatZapp.pdf');
        if (data?.data){
          alert("Timesheet Download Sucessfully")
        }else{ }
      })

      .catch((error) => {
        console.log("Error in categories from Post Form", error);
      });
  };


  // const download = () => {
  //   getData(TIMESHEET_DOWNLOAD)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log("data",data);
  //       // setHire(data);
       
  //     })
  //     .catch((error) => {
  //       console.log("Error in categories from Post Form", error);
  //     });
  // };
  // console.log(hire)
  // useEffect(() => {
  //   // getHire();
  // }, []);

  const {t} = useTranslation();
  return (
    <>
    { hire?.length !=0 ? (hire?.map((item,  index)=>{
      return(
      <div className="col-lg-4 col-md-4 col-sm-12" key={index}>
        <div className="recommended pb-4" onClick={(e)=>{
          e.stopPropagation()
          // props?.timesheetPopup(true)
          navigate('/hire-with-timesheet', {state: {item}})
          }}>
          <div className="row">
            <div className="col-md-4 col-sm-12 unlocked-profile-boxx relative px-0  mb-sm-custom">
            {item?.seeker_details[0]?.is_premium &&
                      <div style={{position:'absolute', top:'0', left:'0'}}>
                      <img
                      src="./images/premium-tag.png"
                      className="premium-tag"
                      // title="Call"
                      alt=""
                    />
                      </div>
                      }
                      <div className="profile-img-box">
              <img src={item?.seeker_details[0]?.image} alt="" className="profile-img" />
              {/* <div className="view-profile horizontal-center"
               style={{cursor:"pointer"}}
              onClick={(e)=>{
                e.stopPropagation()
                setBlackScreenPopup(true)
                


              }}>
              <span className="view-profile-link" style={{}}>{t('View Full Profile')}</span>
              </div> */}
              </div>
             
            </div>
            <div className="col-md-8 col-sm-12 flex-column d-flex justify-content-center my-0">
              <h2
                className="card-heding relative"
                // onChange={(e) => setHireList(e.target.value)}
              >
               {item?.seeker_details[0]?.first_name} {item?.seeker_details[0]?.last_name}
                <img
                  // src="./images/profile-download.png"
                  src="../images/profile-download.png"
                  style={{ height: "unset", width: "unset" }}
                  alt=""
                  className="addprofile"
                  onClick={(e)=>{
                    e.stopPropagation();
                    download(item?.timesheet_id) ; 
                    // setClientDetail(true)
                    
                  }}

                  
                  // onChange={(e) => setHireList(e.target.value)}
                />
                {/* {clientDetail ? (
                    <ClientDetails
                    setData = {setData}
                      closePopup={() => {
                        setClientDetail(false);
                      }}
                    />
                  ) : null} */}
                
              </h2>
              <p
                className="hired-designation"
                // onChange={(e) => setHireList(e.target.value)}
              >
                {item?.seeker_details[0]?.profile_title}
              </p>
              <div className="row mt-1">
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {t('Hired Date')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="profile-info"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {moment(item?.hire_date , 'DD-MM-YYYY')?.format('DD MMM YYYY')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {t('Job Duration')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="profile-info"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {moment(item?.from_date)?.format('D MMM YYYY')} - {moment(item?.to_date)?.format('D MMM YYYY')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {t('Hours Worked')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="profile-info"
                    // onChange={(e) => setHireList(e.target.value)}
                  >
                    {" "}
                    {item?.hours_worked} {lang && Object.keys(lang).length > 0 ? lang[ln]?.HireDetails["Hours"]:""}{" "}
                  </p>
                </div>
              </div>
              {/* <hr className="blue-line-bottom" />
              <hr className="blue-line" /> */}
            </div>
          </div>
          {(blackScreenPopup) &&
                  <div className='blur-screen-full-area flex-center' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', background:'rgb(0, 0, 0, 0.7' }}>
                     <HireBoxBlackScreen item={item} setBlackPopupValue={setBlackScreenPopup} />
                  </div>
                }
        </div>
      </div> )
    })):<div style={{display:"flex", justifyContent:'center', alignItems:'center', marginTop:'70px', color:'grey', fontSize:'20px', marginBottom:'70px'}}>{t('No Data Found')}</div>}
    </>
  );
};

export default HireBox;
